import {gsap, TimelineLite} from "gsap";
import {IndividualWinView} from "./IndividualWinView";
import {RockBottom} from "../../RockBottom";
import {IBetWayWinData} from "../../server/data/IRockBottomData";
import {RockBottomParsedGameData} from "../../server/data/RockBottomParsedGameData";
import {RockBottomParsedInitData} from "../../server/data/RockBottomParsedInitData";
import {RockBottomGameMode} from "../../server/RockBottomGameMode";

export class IndividualWinController {

    private _view: IndividualWinView;
    private _currentTimeline: TimelineLite | null;
    private _stopped: boolean;

    constructor() {
        this._view = new IndividualWinView();
    }

    public start(): void {
        const parsedData: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData();
        if ((parsedData.mode === RockBottomGameMode.FREESPIN || parsedData.mode === RockBottomGameMode.SUPER_FREESPIN) && parsedData.nextMode === RockBottomGameMode.NORMAL) {
            return;
        }
        this._stopped = false;
        if (parsedData.betWins.length > 0 && (!(RockBottom.apiPlugin.freeFeatureBet.hasFreeFeatureBet()))) {
            // Add a small delay for the first time so we don't start to play before the autoPlay start next spin.
            this.playNextBetWin(0, 1);
        }
    }

    public async stop(): Promise<any> {
        this._stopped = true;
        if (this._currentTimeline && this._currentTimeline.isActive()) {
            await this._currentTimeline.progress(1);
        }
        this._currentTimeline = null;
        await Promise.resolve();
    }

    private playNextBetWin(index: number, delay: number = 0): void {
        if (this._stopped) {
            return;
        }
        // TODO: reset all win state if needed.

        const data: RockBottomParsedGameData = RockBottom.model.parsedGameData,
            winRatio: number = data.currentWinRatioConfig?.ratio!,
            tl: gsap.core.Timeline = gsap.timeline(),
            isSingleWinBelowStake: boolean = (RockBottom.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= RockBottom.getBetPriceForSingleWin()));

        if (index === data.betWins.length) {
            index = 0;
        }

        tl.add(this.getBetWayAnimation(<IBetWayWinData>data.betWins[index], winRatio), delay);
        let betWinData: IBetWayWinData = <IBetWayWinData>data.betWins[index];

        if (!isSingleWinBelowStake && data.mode !== RockBottomGameMode.WINCAP_PICK) {
            tl.add(() => RockBottom.initialCountUp.showToggleWinAmountNWays(data.betWins[index].multipliedAmount, betWinData.numberOfCombinations, true), delay);
        }

        tl.add(() => {
            if (!this._stopped) {
                this.playNextBetWin(index + 1);
            }
        });
        this._currentTimeline = tl;
    }

    private getBetWayAnimation(winData: IBetWayWinData, winRatio: number): TimelineLite {
        const tl = gsap.timeline();
        winData.reelWinPositions.forEach((reelWin, reelId) => {
            reelWin.forEach((symWin, symId) => {
                if (symWin) {
                    tl.add(this.getSymbolWinAnimation(reelId, symId, winRatio), 0);
                }
            });
        });
        return tl;
    }

    private getSymbolWinAnimation(reelId: number, symId: number, winRatio: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            sym = RockBottom.reels[reelId].getSymbol(symId, false, false);

        tl.add(() => RockBottom.reels[reelId].reelView.addWinSymbol(sym));
        tl.add(this._view.playAnimation(sym));

        return tl;
    }
}